import { Box, Typography } from '@mui/material'
import { useAppTheme } from '@/theme/ThemeContext'

export default function InterfaceStatusTable() {
  const { mode } = useAppTheme()
  const isDarkMode = mode === 'dark'

  const textColor = isDarkMode ? '#FFFFFF' : '#003F61'
  const subTextColor = isDarkMode ? '#94A3B8' : '#8F98A5'
  const borderColor = isDarkMode ? '#374151' : '#E4E7EB'

  return (
    <Box
      sx={{
        direction: 'rtl',
        width: '100%',
        maxWidth: '800px',
        px: 2,
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
      }}
    >
      <Box
        sx={{
          border: `1px dashed ${borderColor}`,
          borderRadius: '10px',
          px: 3,
          py: 3,
        }}
      >
        <Typography
          sx={{
            fontFamily: 'Rubik, sans-serif',
            fontSize: '15px',
            fontWeight: 500,
            color: textColor,
            textAlign: 'right',
          }}
        >
          סטטוס ממשקים אינו זמין עדיין
        </Typography>
        <Typography
          sx={{
            fontFamily: 'Rubik, sans-serif',
            fontSize: '14px',
            fontWeight: 400,
            color: subTextColor,
            textAlign: 'right',
            mt: 1,
          }}
        >
          אין במערכת מקור נתונים לסטטוס הממשקים. הנתונים יוצגו כאן לאחר שהממשקים
          ידווחו על עצמם.
        </Typography>
      </Box>
    </Box>
  )
}
